module.exports = __webpack_public_path__ + "media/ming_home.cf0b2456.wav";